import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DateService {

  transformDateInputToDate(newDate: any): any {
    const date = newDate.split('T')[0];
    const time = newDate.split('T')[1];
    const dateMoment = moment();
    dateMoment.date(date.split('-')[2]);
    dateMoment.month(date.split('-')[1] - 1);
    dateMoment.year(date.split('-')[0]);
    dateMoment.hour(time.split(':')[0]);
    dateMoment.minutes(time.split(':')[1]);

    return dateMoment;
  }

}
